export type AttachmentModel = {
  id: number,
  attachable_id?: number,
  attachable_type?: string,
  attachment_type?: string,
  cache_key?: number,
  content_type?: string,
  data?: {
    image_type?: string,
    imported?: boolean,
    outdated?: boolean,
    presigned_url?: string,
    revised: [],
    review_status?: string,
  },
  dates: {
    created: {
      date_time: string,
    },
  },
  dimensions?: {
    original?: {
      height?: number,
      width?: number,
    },
    thumb?: {
      height?: number,
      width?: number,
    },
  },
  file?: string,
  file_content_type?: string,
  file_file_name?: string,
  file_file_size?: number,
  file_name?: string,
  links: {
    original_url?: string,
    thumb_url?: string,
  },
  title?: string,
}

export type AttachmentRequestOptions = {}

const state = {
  attachable_id: undefined,
  attachable_type: '',
  attachment_type: '',
  data: {},
  file: '',
  file_content_type: '',
  file_file_name: '',
  id: null,
}

export const requiredFields = [
  { key: 'attachable_id' },
  { key: 'attachable_type' },
]

export default state
